import { render, staticRenderFns } from "./ProductCompanyGroupsEditorCard.vue?vue&type=template&id=22778101&scoped=true&"
import script from "./ProductCompanyGroupsEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductCompanyGroupsEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22778101",
  null
  
)

export default component.exports